(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('StaffController', StaffController);

  /* ngInject */
  function StaffController($filter, formErrorsService, sessionService, staffService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.getStaffUsers = getStaffUsers;
    vm.loading = true;
    vm.staffUsers = [];

    vm.getStaffUsers();

    function getStaffUsers() {
      staffService(sessionService.getAuthToken()).query(response => {
        vm.loading = false;
        vm.staffUsers = response;
      });
    }
  }
})();
